import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import LoginFormBase from "@components/Form/LoginFormBase";

const LoginForm = () => {
    const { login } = useContext(AuthContext);

    return <LoginFormBase onSubmit={login} displayEmail />;
};

export default LoginForm;
